import { X } from "lucide-react";

export default function DismissXButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      className="absolute p-1 transition-opacity duration-300 rounded-md right-1 top-1 md:right-2 md:top-2 text-neutral-500 hover:text-neutral-700 focus:text-neutral-700 focus:outline-none group-hover:text-neutral-700"
      onClick={onClick}
    >
      <X className="w-6 h-6" />
    </button>
  );
}
